import React from "react";
import { colors } from "./theme";
import styled, { css } from "styled-components";

const Label = styled.label`
  line-height: 18px;
  -webkit-box-align: center;
  align-items: center;
  margin-bottom: 8px;
  display: inline-block;
  position: relative;
  white-space: nowrap;
  background: ${({ theme }) => theme.grey};
  border-radius: 3em;
  padding: 1px;
  ${(props) =>
    props.$state
      ? css`
          span:first-of-type {
            background: ${({ theme }) => theme.primaryOne};
            box-shadow: rgba(0, 0, 0, 0.2) 0 0 2px;
            color: white;
            font-weight: bold;
            padding: 7px 15px;
          }
        `
      : css`
          span:last-of-type {
            background: ${({ theme }) => theme.primaryOne};
            box-shadow: rgba(0, 0, 0, 0.2) 0 0 2px;
            color: white;
            font-weight: bold;
            padding: 7px 15px;
          }
        `}
`;

const Input = styled.input`
  appearance: none;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 3em;
`;

const Span = styled.span`
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  display: inline-block;
  padding: 7px 15px;
  user-select: none;
  border-radius: 3em;
  color: rgba(51, 51, 51, 0.6);
  background: transparent;
`;
const Switch = ({ state, setState, trueLabel, falseLabel }) => {
  return (
    <>
      <Label $state={state}>
        <Input type={"checkbox"} onClick={(e) => setState(!state)} />
        <Span>{trueLabel}</Span>
        <Span>{falseLabel}</Span>
      </Label>
    </>
  );
};

export default Switch;
